// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3OfVO","content":"RecentSearches_content__3Dgsv"};